import { FilterChip, Button } from '@cmsgov/ds-medicare-gov';
import type { Facets } from '../types';
import type { Lang, FacetKey } from '../constants';
import { FACETS } from '../constants';
import { t } from '../i18n';
import './FilterChips.css';

interface FilterChipsProps {
  lang: Lang;
  facets: Facets | null;
  activeFilters: Record<FacetKey, number[]>;
  onRemove: (facetKey: FacetKey, tid: number) => void;
  onReset: () => void;
}

export function FilterChips({
  lang,
  facets,
  activeFilters,
  onRemove,
  onReset,
}: FilterChipsProps) {
  const strings = t(lang);

  const chips: { facetKey: FacetKey; tid: number; label: string }[] = [];

  for (const key of Object.values(FACETS)) {
    const tids = activeFilters[key] || [];
    const terms = facets?.[key] || [];
    for (const tid of tids) {
      const term = terms.find((t) => t.tid === tid);
      if (term) {
        chips.push({ facetKey: key, tid, label: term.name });
      }
    }
  }

  if (chips.length === 0) return null;

  return (
    <div className="ds-u-display--none ds-u-lg-display--block app-library-search__filter-chips" aria-label="Active filters">
      <div className="app-library-search__filter-chips-wrapper">
        <div className="app-library-search__filter-chips-container">
          {chips.map((chip) => (
            <FilterChip
              key={`${chip.facetKey}-${chip.tid}`}
              label={chip.label}
              onDelete={() => onRemove(chip.facetKey, chip.tid)}
              className="app-library-search__filter-chips-chip ds-c-filter-chip"
              useAlternateIcon={true}
              size="big"
            />
          ))}
          <Button variation="ghost" size="small" onClick={onReset} className="app-library-search__filter-chips-clear">
            {strings.clearAllFilters}
          </Button>
        </div>
      </div>
    </div>
  );
}
